/* eslint-disable sort-keys */
const jsToCSSVariable = (variables) => {
    variables.forEach(v => {
        document.querySelector(':root').style.setProperty(`--${v.key}`, v.value);
    });
};
const defaultBranding = {
    apiRoot: '',
    brand: '',
    partnerId: '',
    website: '',
    companyLogoSrc: '',
    branding: {
        supportEmail: '',
        supportPhone: '',
        termsUrl: '',
        refundsUrl: '',
        contactsUrl: '',
        helpUrl: '',
        twitter: '',
        twitterUrl: '',
        forgotPasswordLocation: '/faces/forgotPassword.xhtml',
        // styles
        fontFamily: 'Open Sans',
        fontImportUrl: 'https://fonts.googleapis.com/css?family=Open+Sans:300,400,700&display=swap',
        colorPrimary: '#006eb3',
        colorSecondary: '#171717',
        colorSuccess: '#28a745',
        colorDanger: '#dc3545',
        colorWarning: '#ffc107',
        colorInfo: '#17a2b8',
        fontWeights: {
            light: '300',
            regular: '400',
            semibold: '700',
            bold: '700',
        },
        topbarInverted: false,
    },
    apps: {
        manager: {
            enabled: true,
            color1: '#006eb3',
            color2: '#171717',
            favicons: [],
            url: '',
        },
        analytics: {
            enabled: true,
            color1: '#006eb3',
            color2: '#171717',
            favicons: [],
            url: '/apps/analytics',
        },
        communicator: {
            enabled: true,
            color1: '#006eb3',
            color2: '#171717',
            favicons: [],
            url: '/apps/phone',
        },
    },
};
const fetchBranding = async (partnerId) => {
    const brandingAPI = process.env.NODE_ENV === 'development' ||
        process.env.PLATFORM === 'electron'
        ? 'https://api.branding.partner.sipcentric.com/branding'
        : '/branding_api';
    const headers = {};
    if (partnerId) {
        headers['X-Partner-Id'] = partnerId;
    }
    else if (process.env.NODE_ENV === 'development' ||
        process.env.PLATFORM === 'electron') {
        headers['X-Partner-Id'] = process.env.PARTNER_ID || '69';
    }
    try {
        const request = await fetch(brandingAPI, {
            headers,
        });
        if (request.status >= 400)
            throw new Error();
        let brand = await request.json();
        brand = brand.data;
        if (brand) {
            localStorage.setItem('nv-branding', JSON.stringify(brand));
            return { brand, isLive: true };
        }
        throw new Error();
    }
    catch {
        const cachedBranding = JSON.parse(localStorage.getItem('nv-branding') || 'null');
        console.error(`Failed to fetch branding. Using ${cachedBranding ? 'cached' : 'default'} branding...`);
        return { brand: cachedBranding || defaultBranding, isLive: false };
    }
};
const faviconsToHead = (favicons) => {
    const faviconToElementMap = new Map([
        [
            'apple-touch-icon.png',
            `<link rel="apple-touch-icon" sizes="57x57" href="`,
        ],
        [
            'android-chrome-512x512.png',
            `<link rel="icon" type="image/png" sizes="512x512" href="`,
        ],
        [
            'android-chrome-192x192.png',
            `<link rel="icon" type="image/png" sizes="192x192" href="`,
        ],
        [
            'favicon-16x16.png',
            `<link rel="icon" type="image/png" sizes="16x16" href="`,
        ],
        [
            'favicon-32x32.png',
            `<link rel="icon" type="image/png" sizes="32x32" href="`,
        ],
        ['mstile-150x150.png', `<meta name="msapplication-TileImage" content="`],
        ['site.webmanifest', `<link rel="manifest" href="`],
        ['browserconfig.xml', `<meta name="msapplication-config" content="`],
        // * omit these because they aren't defined in browserconfig.xml
        // [ 'mstile-70x70.png', `<meta name="msapplication-TileImage" content="` ],
        // [ 'mstile-144x144.png', `<meta name="msapplication-TileImage" content="` ],
        // [ 'mstile-310x150.png', `<meta name="msapplication-TileImage" content="` ],
        // [ 'mstile-310x310.png', `<meta name="msapplication-TileImage" content="` ],
    ]);
    let faviconElements = `
  <meta name="msapplication-TileColor" content="#FFFFFF">
  <meta name="theme-color" content="#FFFFFF">`;
    favicons.forEach(favicon => {
        const faviconElement = faviconToElementMap.get(favicon.name)
            ? `${faviconToElementMap.get(favicon.name)}${favicon.location}">`
            : undefined;
        faviconElements += faviconElement || '';
    });
    document.head.innerHTML += faviconElements;
};
const applyBranding = (brand, appName, applyFavicons = true) => {
    const { branding } = brand;
    let fontStyle = `<link href="${branding.fontImportUrl}" rel="stylesheet">`;
    if (branding.fontTabularImportUrl) {
        fontStyle += `\n<link href="${branding.fontTabularImportUrl}" rel="stylesheet">`;
    }
    document.head.innerHTML += fontStyle;
    const variables = [
        { key: 'font-family', value: branding.fontFamily },
        {
            key: 'font-family-tabular',
            value: branding.fontTabularFamily || branding.fontFamily,
        },
        { key: 'font-weight-light', value: branding.fontWeights.light },
        { key: 'font-weight-regular', value: branding.fontWeights.regular },
        { key: 'font-weight-semibold', value: branding.fontWeights.semibold },
        { key: 'font-weight-bold', value: branding.fontWeights.bold },
        { key: 'primary', value: branding.colorPrimary },
        { key: 'secondary', value: branding.colorSecondary },
        { key: 'success', value: branding.colorSuccess },
        { key: 'danger', value: branding.colorDanger },
        { key: 'info', value: branding.colorInfo },
        { key: 'warning', value: branding.colorWarning },
    ];
    jsToCSSVariable(variables);
    if (appName && brand.apps[appName]?.favicons && applyFavicons) {
        faviconsToHead(brand.apps[appName].favicons);
    }
};
/**
 * @description Resets branding to default and clears the cached branding in local storage
 */
const resetBranding = (clearCache = false) => {
    applyBranding(defaultBranding);
    if (clearCache) {
        localStorage.removeItem('nv-branding');
    }
};

export { applyBranding, defaultBranding, fetchBranding, resetBranding };
//# sourceMappingURL=branding.js.map
